module.exports = __webpack_public_path__ + "static/media/loops.2ebfc6c6.jpg";